import {
  GET_ORPHANS_LIST_LOADING,
  GET_ORPHANS_LIST_SUCCESS,
  GET_ORPHANS_LIST_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { getOrphansListUrl } from "api/apiUrls";

export const getOrphansListActions =
  (gender?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: GET_ORPHANS_LIST_LOADING, payload: true });
      const response = await listItemsService(
        `${getOrphansListUrl}`,
        `gender=${gender}`
      );

      dispatch({ type: GET_ORPHANS_LIST_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: GET_ORPHANS_LIST_FAILURE, payload: err });
    } finally {
      dispatch({ type: GET_ORPHANS_LIST_LOADING, payload: false });
    }
  };
